import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = {
  text: {
    color: 'white',
  },
  progress: {
    marginLeft: '8px',
  },
};

class PlayerCount extends React.Component {
  constructor() {
    super();
    this.state = {
      nb: 0,
      loading: true,
    };
    this.checks = 40;
    this.checkPlayerCount = this.checkPlayerCount.bind(this);
    this.updatePlayerCount = this.updatePlayerCount.bind(this);
  }

  componentDidMount() {
    this.updatePlayerCount();
  }

  checkPlayerCount() {
    fetch('https://api.bloodybattle.net/playerCount')
      .then(res => res.json())
      .then(data => this.setState({ nb: data.nb, loading: false }))
      .catch((error) => {
        this.setState({ nb: 404, loading: false });
      });
  }

  updatePlayerCount() {
    this.checkPlayerCount();
    this.checks -= 1;
    if (this.checks > 0) setTimeout(this.updatePlayerCount, 7000);
  }

  render() {
    const { loading, nb } = this.state;
    const playerNb = (loading)
      ? (
        <CircularProgress
          size={15}
          thickness={5}
          color="inherit"
          style={styles.progress}
        />
      )
      : nb;

    return (
      <React.Fragment>
        <span style={styles.text}>Joueurs en ligne: </span>
        {playerNb}
      </React.Fragment>
    );
  }
}

export default PlayerCount;



// WEBPACK FOOTER //
// ./src/layout/PlayerCount.js